import React from "react";
//import GravityFormForm from "gatsby-gravityforms-component";
import GravityFormForm from "gatsby-plugin-gravity-forms";
import parse from "html-react-parser";
import classNames from "classnames";
//
import "./contactForm.scss";
import { graphql, useStaticQuery } from "gatsby";
import Img from "components/img/img";
import { useThemeSettings } from "hooks/queries/useThemeSettings.query";

interface Props {
  isFooterLayout?: boolean;
  formId?: number;
}

const ContactForm: React.FC<Props> = (props) => {
  const themeSettings = useThemeSettings(); // from theme options
  const data = useStaticQuery(graphql`
    query formQuery {
      wpGfForm(databaseId: { eq: 1 }) {
        ...GravityFormFields
      }
    }
  `);

  const handleSuccess = () => {
    //console.log("success");
  };

  const handleError = (e: any) => {
    //console.log("error", e);
  };

  const { headline, footerBlocks, backgroundImage, formId } =
    themeSettings.wp.themeGeneralSettings.formBlockSettings;

  return (
    <div
      className={classNames("contact-form", {
        "is-layout-footer": props.isFooterLayout,
        "is-layout-default": !props.isFooterLayout,
      })}
    >
      {props.isFooterLayout && !!backgroundImage && (
        <Img {...backgroundImage} className="contact-form-background" />
      )}

      <div className="contact-form__wrapper wrapper">
        <div className="contact-form__inner">
          {props.isFooterLayout && (
            <h4 className="contact-form__headline">{headline}</h4>
          )}

          <div className="contact-form-form">
            <GravityFormForm
              id={props.isFooterLayout ? formId : props.formId}
              data={data}
              lambda={process.env.GATSBY_LAMBDA_ENDPOINT}
              uccessCallback={handleSuccess}
              errorCallback={handleError}
            />
          </div>
          <div className="contact-form-footer">
            {footerBlocks.map((item: any, key: any) => (
              <div className="contact-form-footer__item" key={key}>
                <b>{parse(item.headline)}</b>
                {parse(item.text)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;

export const query = graphql`
  fragment ContactFormBlock on WpAcfContactformBlock {
    AcfContactForm {
      formId
    }
  }
`;
